import { defaultTicketDescription } from "app/containers/Features/containers/Ticket/redux/initialState";
import { ITicketFormData, TicketGroupsState } from "../types";

export const defaultTicketFormDetail: ITicketFormData = {
  groupId: "",
  projectId: "",
  title: "",
  color: "",
  type: "",
  status: "",
  assignedTo: "",
  dueDate: "",
  effortEstimated: {},
  effortActual: {},
  tags: [],
  description: { ...defaultTicketDescription },
  checklists: [],
  attachments: [],
  customFields: [],
  release: "",
  sprint: "",
  epic: "",
  file: [],
  priority: "",
};

export const initialState: TicketGroupsState = {
  groupForm: {
    name: {
      value: "",
      error: "",
    },
    description: {
      value: "",
      error: "",
    },
  },
  groups: [],
  isLoading: false,
  ticketFormData: { ...defaultTicketFormDetail },
  groupingLoader: false,
  groupingTicketsLoader: false,
  ticketCache: {},
  showCreateTicketIntoGroup: {
    groupId: "",
    actions: false,
    subGroupId: undefined,
  },
  groupsPagination: {},
  isSubgroupCollapsed: {},
};
